import ForgeSDK from 'wz-forge-sdk';

const STORAGE_KEY = 'wz_forge_config';

const sdk = new ForgeSDK({
  projectKey: 'ssz_zky',
  appSecret: 'a93a5264ecd10b30312bc3588e9c5d4004257497cec39876849f0a2c3e15cfcf',
  env: 'prd',
  configKey: 'web' // 可选，多个配置 key 英文逗号分隔，不传则返回项目下所有配置
});

const state = {
  config: JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}')
};

const getters = {
  // 不传 key 返回全部配置，传 key 返回对应值
  get_forge_config: state => key => {
    if (key === undefined) return state.config;
    return state.config[key] ?? '';
  }
};

const mutations = {
  // 合并配置，同时持久化到 localStorage
  set_forge_config(state, newConfig) {
    if (!newConfig || typeof newConfig !== 'object') return;
    state.config = { ...state.config, ...newConfig };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state.config));
  }
};

const actions = {
  init({ commit, state }) {
    try {
      console.log('拉取配置');
      sdk
        .fetch()
        .then(res => {
          console.log('获取系统配置', res);
          if (res && res.web) {
            commit('set_forge_config', res.web);
          }
        })
        .catch(err => {
          console.error('[ForgeSDK] 拉取配置失败:', err);
        });
    } catch (error) {
      console.error(`[error] ${error} `);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
